// extracted by mini-css-extract-plugin
module.exports = {"asosFocus":"_1aufEaZ","burger":"_31ffwSC _1aufEaZ","burger__hidden":"_36GSV1Q"};